export default "__VITE_ASSET__BE$KA9Nd__"